'use strict';

const translator = require('./../../core/translator');
const Container = require('./../../core/container');

module.exports = {
  'events': {
    'menu:ready': [
      {
        'callback': function(add) {
          if (Container.get('page.uid') && Container.get('isAllowedTo')('CREATE_PAGE')) {
            add(translator.translate('new_page'), 'new-page', 20, 'new-page');
          }
          add(translator.translate('search_page'), 'search', 30, 'search-page');
          if (Container.get('page.uid') && (Container.get('isAllowedTo')('EDIT_PAGE') || Container.get('isAllowedTo')('DELETE_PAGE') || Container.get('isAllowedTo')('PUBLISH_PAGE'))) {
            add(translator.translate('page_parameters'), 'page-parameters', 40, 'page-parameters');
          }
        },
      },
      {'callback': require('./service/hasContentToPublish').init},
    ],
    'before:show-form:auth': [
      {'callback': require('./views/search').beforeShowFormAuth},
    ],
    'before:render:menu-item': [
      {'callback': require('./views/pageOnlineSwitch').beforeRenderMenu},
    ],
    'menu:page-online-switch:click': [
      {'callback': require('./views/pageOnlineSwitch').onClick},
    ],
    'menu:new-page:click': [
      {'callback': require('./views/new').init},
    ],
    'menu:page-parameters:click': [
      {'callback': require('./views/parameters').init},
    ],
    'menu:search-page:click': [
      {'callback': require('./views/search').init},
    ],
    'on:logout': [
      {'callback': require('./listener/logout').onLogout},
    ],
    'after:logout': [
      {'callback': require('./listener/logout').afterLogout},
    ],
    'menu:more-parameters:ready': [
      {
        'callback': function(items) {
          if (Container.get('isAllowedTo')('SEO_TRACKING_FEATURE')) {
            items.push({'name': 'analytics_seo_tools', 'pos': 10});
          }
        },
      },
    ],
    'menu:analytics_seo_tools:ready': [
      {
        'callback': function(items) {
          items.push({'name': 'website_on_google', 'pos': 10});
          items.push({'name': 'analytics', 'pos': 10});
          items.push({'name': 'knowledge_graph', 'pos': 10});
          items.push({'name': 'gsc', 'pos': 10});
          items.push({'name': 'matomo', 'pos': 10});
        },
      },
    ],
    'menu:more-parameters:analytics_seo_tools:click': [
      {'callback': require('./../../services/structure/menu/panel').init.bind(undefined, 'analytics_seo_tools')},
    ],
    'menu:analytics_seo_tools:website_on_google:click': [
      {'callback': require('./service/robot').onClick},
    ],
    'menu:analytics_seo_tools:analytics:click': [
      {'callback': require('./service/analytics').onClick},
    ],
    'menu:analytics_seo_tools:knowledge_graph:click': [
      {'callback': require('./service/knowledgeGraph').onMenuClick},
    ],
    'menu:analytics_seo_tools:gsc:click': [
      {'callback': require('./service/googleSearchConsole').onMenuClick},
    ],
    'menu:analytics_seo_tools:matomo:click': [
      {'callback': require('./service/matomo').onMenuClick},
    ],
    'on:error:500': [
      {'callback': require('./../../services/structure/menu').onError500},
    ],
  },
};
